export default "__VITE_ASSET__BaiqqMpT__"